import React from 'react'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

export default function Copyright() {
  const fullYear = new Date().getFullYear()
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://tangelo.ai">
        TangeloAi
      </Link>
      {` ${fullYear}`}
    </Typography>
  )
}
